'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# BriefcaseBadgeSVG
An SVG badge shaped like the state of Ohio containing a briefcase icon
 */
var BriefcaseBadgeSVG = function BriefcaseBadgeSVG(_ref) {
  var height = _ref.height,
      width = _ref.width,
      badgeColor = _ref.badgeColor,
      iconColor = _ref.iconColor;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 473 492',
      'aria-label': 'Briefcase Badge',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'Briefcase Badge'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'A badge shaped like the state of Ohio containing a briefcase icon'
    ),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement(
        'g',
        {
          fillRule: 'nonzero'
        },
        _react2.default.createElement(
          'g',
          {
            fill: badgeColor
          },
          _react2.default.createElement('path', {
            d: 'M464.273966,0.977586207 C473.081552,-0.570258621 472.266034,8.06508621 472.266034,13.1974138 C472.429138,79.1030172 472.429138,145.090086 472.429138,210.99569 C472.429138,274.294397 471.858276,335.230603 471.858276,398.610776 C465.578793,400.973276 459.462414,403.417241 453.182931,405.942672 C391.529828,429.404741 330.039828,452.86681 268.549828,476.573276 C258.763621,480.402155 252.647241,482.846121 240.414483,487.815517 C232.911724,491.074138 231.28069,489.607759 224.104138,487.000862 C213.828621,482.438793 205.26569,479.506034 194.337759,475.269828 C129.748793,450.178448 65.2413793,425.575862 0.489310345,400.647414 C0.489310345,272.746552 0.489310345,145.008621 0.489310345,17.0262931 C54.7212069,17.1892241 108.953103,17.7594828 162.940345,17.1892241 C177.048793,17.0262931 186.916552,20.6107759 195.561034,32.5047414 C215.133448,59.7956897 240.903793,68.9198276 273.932241,57.7590517 C298.968621,49.3681034 325.065172,44.8060345 350.264655,37.2297414 C388.675517,25.9060345 426.352414,13.1974138 464.273966,0.977586207 Z'
          })
        ),
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(127.634921, 157.500000)',
            fill: iconColor
          },
          _react2.default.createElement('path', {
            d: 'M0.219530307,116.22807 C0.219530307,87.7192982 0.219530307,59.2105263 0.219530307,30.7017544 C24.6313005,30.7017544 48.9991646,30.7017544 73.5426529,30.7017544 C73.5426529,20.3070175 73.5426529,10.1315789 73.5426529,0 C99.5789474,0 125.659148,0 151.695442,0 C151.695442,10.2192982 151.695442,20.3947368 151.695442,30.7017544 C176.326743,30.7017544 200.694607,30.7017544 225.018565,30.7017544 C225.018565,59.2105263 225.018565,87.7192982 225.018565,116.22807 C197.401652,116.22807 169.78474,116.22807 141.948297,116.22807 C141.948297,111.798246 141.948297,107.675439 141.948297,103.596491 C122.410099,103.596491 103.135338,103.596491 83.597141,103.596491 C83.597141,107.807018 83.597141,111.929825 83.597141,116.22807 C55.6289799,116.22807 27.9242551,116.22807 0.219530307,116.22807 Z M86.7583774,30.6140351 C104.101272,30.6140351 121.224636,30.6140351 138.391906,30.6140351 C138.391906,24.6052632 138.391906,18.7280702 138.391906,12.8508772 C121.092917,12.8508772 103.969554,12.8508772 86.7583774,12.8508772 C86.7583774,18.8157895 86.7583774,24.6052632 86.7583774,30.6140351 Z'
          }),
          _react2.default.createElement('path', {
            d: 'M225.018565,129.824561 C225.018565,139.780702 225.018565,149.692982 225.018565,159.649123 C224.886847,160.04386 224.667316,160.438596 224.579504,160.877193 C222.779356,170.263158 217.466722,176.973684 208.90504,181.052632 C206.885362,182.017544 204.733965,182.587719 202.626474,183.333333 C142.606888,183.333333 82.6312076,183.333333 22.6116216,183.333333 C21.8652186,183.070175 21.1627216,182.763158 20.3724125,182.54386 C13.3913487,180.570175 7.81527894,176.578947 4.30279402,170.307018 C2.45873944,167.017544 1.53671215,163.201754 0.219530307,159.605263 C0.219530307,149.649123 0.219530307,139.736842 0.219530307,129.780702 C27.9681611,129.780702 55.760698,129.780702 83.7288592,129.780702 C83.7288592,135.526316 83.7288592,140.964912 83.7288592,146.359649 C103.267057,146.359649 122.541818,146.359649 142.080015,146.359649 C142.080015,140.833333 142.080015,135.394737 142.080015,129.780702 C169.872552,129.824561 197.445558,129.824561 225.018565,129.824561 Z'
          }),
          _react2.default.createElement('path', {
            d: 'M96.8567716,133.070175 C96.8567716,127.675439 96.8567716,122.412281 96.8567716,117.017544 C107.306414,117.017544 117.712151,117.017544 128.249605,117.017544 C128.249605,122.324561 128.249605,127.631579 128.249605,133.070175 C117.887775,133.070175 107.482038,133.070175 96.8567716,133.070175 Z'
          })
        )
      )
    )
  );
};

BriefcaseBadgeSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  badgeColor: _propTypes2.default.string,
  iconColor: _propTypes2.default.string
};

BriefcaseBadgeSVG.defaultProps = {
  height: undefined,
  width: undefined,
  badgeColor: _config.colors.darkRed,
  iconColor: _config.colors.white
};

BriefcaseBadgeSVG.displayName = 'BriefcaseBadgeSVG';

exports.default = BriefcaseBadgeSVG;
BriefcaseBadgeSVG.__docgenInfo = {
  'description': '# BriefcaseBadgeSVG\r\nAn SVG badge shaped like the state of Ohio containing a briefcase icon',
  'methods': [],
  'displayName': 'BriefcaseBadgeSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'badgeColor': {
      'defaultValue': {
        'value': 'colors.darkRed',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'iconColor': {
      'defaultValue': {
        'value': 'colors.white',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    }
  }
};